// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__8n1Jj","resendInfoText":"OnGoingPaymentBox_resendInfoText__1113q"};